/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewRoot_viewer = {
    readonly tradePortfolioInstagram: boolean | null;
    readonly tradeFirms?: ReadonlyArray<{
        readonly publicProfile: {
            readonly articles: ReadonlyArray<{
                readonly webLink: {
                    readonly url: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly instagram: {
            readonly __id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"OverviewAbout_tradeFirm" | "OverviewAwards_tradeFirm" | "OverviewArticles_tradeFirm" | "OverviewWeblinks_tradeFirm" | "OverviewInstagram_tradeFirm" | "OverviewFavorites_tradeFirm" | "OverviewProjects_tradeFirm">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"OverviewInstagram_viewer" | "OverviewAwards_viewer">;
    readonly " $refType": "OverviewRoot_viewer";
};
export type OverviewRoot_viewer$data = OverviewRoot_viewer;
export type OverviewRoot_viewer$key = {
    readonly " $data"?: OverviewRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewRoot_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewRoot_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "shouldRenderOverview",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "tradePortfolioInstagram",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "tradePortfolioInstagram"
        }
      ],
      "storageKey": "featureFlag(feature:\"tradePortfolioInstagram\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "OverviewInstagram_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "shouldRenderOverview",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirms",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "urlLabel",
              "variableName": "firmUrlLabel"
            }
          ],
          "concreteType": "TradeFirmType",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "publicProfile",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmPublicProfileType",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "articles",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "DesignFirmArticleType",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "webLink",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "WebLink",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "url",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "instagram",
              "storageKey": null,
              "args": null,
              "concreteType": "InstagramFeedType",
              "plural": false,
              "selections": [
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "__id",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewAbout_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewAwards_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewArticles_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewWeblinks_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewInstagram_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewFavorites_tradeFirm",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "OverviewProjects_tradeFirm",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "OverviewAwards_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '1b15bcd3e523c274ef132d80815eca2d';
export default node;
